// Quicklinks collections : carousel avec flèches en desktop quand la liste déborde
(function () {
  const wrapper = document.getElementById('filtres_collections');
  const nav = wrapper && wrapper.querySelector('nav');
  if (!nav) return;

  const prev = wrapper.querySelector('.filtres_collections__arrow--prev');
  const next = wrapper.querySelector('.filtres_collections__arrow--next');

  const update = () => {
    const maxScroll = nav.scrollWidth - nav.clientWidth;
    wrapper.classList.toggle('is-overflowing', maxScroll > 0);
    prev.hidden = nav.scrollLeft <= 1;
    next.hidden = nav.scrollLeft >= maxScroll - 1;
  };

  // Fait défiler d'une "page" de liens, avec un léger recouvrement pour garder un repère visuel
  const slide = (direction) => {
    nav.scrollBy({ left: direction * nav.clientWidth * 0.8, behavior: 'smooth' });
  };

  prev.addEventListener('click', () => slide(-1));
  next.addEventListener('click', () => slide(1));

  // Centre le lien actif s'il est hors de la zone visible
  const active = nav.querySelector('a.active');
  if (active) {
    nav.scrollLeft = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
  }

  update();
  nav.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
